<img src="/svg/logos/PaxrayLogoSmall.svg" alt="Paxray Logo" />

<style>
  img {
    position: relative;
    width: 100%;
    max-height: 100%;
  }
</style>
